import React, { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const FluentPlay: FC<{ fillColor?: string } & SvgProps> = ({
  fillColor = '#212121',
  ...props
}) => (
  <Svg width={24} height={24} fill='none' viewBox='0 0 24 24' {...props}>
    <Path
      d='M7.608 4.615a.75.75 0 00-1.108.659v13.452a.75.75 0 001.108.659l12.362-6.726a.75.75 0 000-1.318L7.608 4.615zM5 5.274c0-1.707 1.826-2.792 3.325-1.977l12.362 6.726c1.566.853 1.566 3.101 0 3.953L8.325 20.702C6.826 21.518 5 20.432 5 18.726V5.274z'
      fill={fillColor}
    />
  </Svg>
)
export default FluentPlay
